export default __webpack_public_path__ + "static/media/am.eaae878c.svg";